const base = 1024;

export const calculateByteSize = (to: "kb" | "mb", byteSize?: number) => {
  if (!byteSize) return 0;
  const divisor = to === "kb" ? base : Math.pow(base, 2);
  return byteSize / divisor;
};
